import * as APITypes from "~/API";
import { LoaderData } from "~/types";
import { ResourceAccessLRUCache } from "./resourceAccess";
import { ResourceLifeLRUCache } from "./resourceLife";
import { getResourceAccess, getResourceLife } from "~/services/server";

export const determineAccessRights = (
  resource: string,
  resourceType: string,
  resourceID: string,
  role?: APITypes.ManagerRolesType
): boolean => {
  return false;
};

export const determineLifeRights = (
  resource: string,
  resourceType: string,
  resourceID: string,
  role?: APITypes.ManagerRolesType
): boolean => {
  return false;
};

/// THis function attempts to get a resource access right from the cache.
/// If it fails, it fetches the resource, updates the cache, and returns the resource.
const getAndUpdateAccessRightCache = async ({
  userID,
  resourceID,
}: {
  userID: string;
  resourceID: string;
}): Promise<LoaderData<APITypes.ResourceUpdateAccessRight>> => {
  const key = `${userID}-${resourceID}`;
  const cacheInstance = ResourceAccessLRUCache.get(key);
  if (cacheInstance.success) {
    return cacheInstance.data;
  }

  const resourceAccess = await getResourceAccess({ userID, resourceID });
  ResourceAccessLRUCache.update({ key, value: resourceAccess });
  return resourceAccess;
};

/// THis function attempts to get a resource access right from the cache.
/// If it fails, it fetches the resource, updates the cache, and returns the resource.
const getAndUpdateLifeRightCache = async ({
  userID,
  resourceType,
}: {
  userID: string;
  resourceType: APITypes.EntityType;
}): Promise<LoaderData<APITypes.ResourceLifeAccessRight>> => {
  const key = `${userID}-${resourceType}`;
  const cacheInstance = ResourceLifeLRUCache.get(key);
  if (cacheInstance.success) {
    return cacheInstance.data;
  }

  const resourceAccess = await getResourceLife({ userID, resourceType });
  ResourceLifeLRUCache.update({ key, value: resourceAccess });
  return resourceAccess;
};
